import { render } from "./ProjectTemplateSelector.vue?vue&type=template&id=5d74cee6&lang=pug"
import script from "./ProjectTemplateSelector.vue?vue&type=script&lang=js"
export * from "./ProjectTemplateSelector.vue?vue&type=script&lang=js"

import "./ProjectTemplateSelector.vue?vue&type=style&index=0&id=5d74cee6&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__